function clearSiteCookies(): void {
  const cookiePairs = document.cookie.split(";");
  if (!cookiePairs.length || (cookiePairs.length === 1 && !cookiePairs[0].trim())) {
    return;
  }

  const hostname = window.location.hostname;
  const expire = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
  const paths = ["/", window.location.pathname];
  const domainVariants = ["", hostname, `.${hostname}`];

  for (const cookie of cookiePairs) {
    const trimmed = cookie.trim();
    if (!trimmed) continue;

    const eqIndex = trimmed.indexOf("=");
    const name = eqIndex >= 0 ? trimmed.slice(0, eqIndex) : trimmed;
    if (!name) continue;

    for (const path of paths) {
      for (const domain of domainVariants) {
        const domainPart = domain ? `;domain=${domain}` : "";
        document.cookie = `${name}=;${expire};path=${path}${domainPart}`;
      }
    }
  }
}

/** Clears localStorage, sessionStorage, and cookies for the current site. */
export function clearSiteData(): void {
  window.localStorage.clear();
  window.sessionStorage.clear();
  clearSiteCookies();
}
